import { Fragment } from 'react';
import useDeviceInfo from '../../../services/helpers/custom_hook/useDeviceInfo';
import SocialLinks from './SocialLinks/SocialLinks';
import './FooterInformation.sass';

const FooterInformation = ({ logo, links, socialLinks }) => {
  const { isMobile } = useDeviceInfo();

  return (
    <div className='footer-information-wrapper'>
      <div
        className='footer-information-clouds'
        style={{ backgroundImage: `url('https://cdn.homierent.com/strapi-media/clouds_desktop_087b94bb42.svg')` }}
      />
      <div className='footer-information-content'>
        <div className='footer-information-left'>
          {isMobile && (
            <div
              className='footer-information-mobile-clouds'
              style={{ backgroundImage: `url('https://cdn.homierent.com/strapi-media/clouds_mobile_d7a41d2d67.svg')` }}
            />
          )}
          <a href={logo.link}>
            <img
              className='footer-information-logo'
              src={logo.url}
              alt='Logo'
            />
          </a>
          {!isMobile && socialLinks && <SocialLinks links={socialLinks} />}
        </div>
        {!isMobile && (
          <div className='footer-information-center'>
            {links.map(({ title, link }, index) => (
              <Fragment key={index}>
                <div>
                  <p>{title}</p>
                  <ul>
                    {link.map(({ link = '', title = '', nofollow }, index) => (
                      <li key={index}>
                        <a href={link} {...(nofollow && { rel: 'nofollow' })}>
                          {title}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </Fragment>
            ))}
          </div>
        )}
        {isMobile && (
          <div className='footer-information-center'>
            {links.map(({ title, link }, index) => (
              <Fragment key={index}>
                <div>
                  <p>{title}</p>
                  <ul>
                    {link.map(({ link = '', title = '', nofollow }, index) => (
                      <li key={index}>
                        <a href={link} rel={nofollow ? 'nofollow' : ''}>
                          {title}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
                {isMobile && index < links.length && (
                  <div className='footer-information-separator' />
                )}
              </Fragment>
            ))}
          </div>
        )}
      </div>
      {isMobile && socialLinks && (
        <SocialLinks title='Síguenos' links={socialLinks} />
      )}
    </div>
  );
};

export default FooterInformation;
